<template>
  <a-modal
    :bodyStyle="{ padding: 0, height: '450px' }"
    :centered="true"
    :footer="null"
    :title="false"
    :width="800"
    class="material-preview"
    v-model="visible"
  >
    <video
      v-if="modalVisible"
      :src="modalVisible.qurl"
      class="preview-material"
      controls="controls"
      ref="materialVideo"
    ></video>
  </a-modal>
</template>
<script>
export default {
  computed: {
    modalVisible() {
      return this.$store.state.currentPresetTemplate;
    },
    visible: {
      get() {
        return !!this.modalVisible;
      },
      set(value) {
        if (!value) {
          this.$store.commit('handleCurrentPresetTemplate', null);
        }
      }
    }
  }
};
</script>
<style scoped>
.material-preview ::v-deep .ant-modal-close-x {
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  color: #ffffff;
  margin: 10px 10px 0 0;
  width: 25px;
  height: 25px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-material {
  width: 800px;
  height: 450px;
}
</style>